import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
// import { User } from 'src/app/core/models/auth.models';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-epp',
  templateUrl: './add-epp.component.html',
  styleUrls: ['./add-epp.component.scss'],
})
export class AddEppComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  EPPForm: FormGroup;
  submitted = false;
  isLoading: boolean;
  keyword = 'UserName';
  currentUser: any;
  baseDocType: any;
  constructor(
    private fb: FormBuilder,
    private gs: GeneralService,
    private router: Router,
    private datepipe: DatePipe
  ) {}
  columns = ['User Id', 'User Name', 'Group Id'];

  index = ['UserID', 'UserName', 'group_id'];

  users = [];

  ngOnInit() {
    this.currentUser = this.gs.getcurrentUser()
    this.breadCrumbItems = [
      { label: 'EPP', path: '/' },
      { label: 'Add Existing EPP', path: '/add', active: true },
    ];
    this.EPPForm = this.fb.group({
      BaseDocument: new FormControl(null, Validators.required),
      StateID:new FormControl(7),
      district: new FormControl('', Validators.required),
      taluka: new FormControl(''),
      village: new FormControl(''),
      survey_number: new FormControl('', Validators.required),
      start_date: new FormControl('', [Validators.required, Validators.pattern('\\d{4}-\\d{2}-\\d{2}')]),
      end_date: new FormControl('', [Validators.required, Validators.pattern('\\d{4}-\\d{2}-\\d{2}')]),
      user_id: new FormControl('', Validators.required),
      group_id: new FormControl(''),
      uname: new FormControl('', Validators.required),
      user: new FormControl(''),
      Admin_ID: new FormControl(this.currentUser.Id),
      citysurveyoffice: new FormControl(''),
      ward: new FormControl(''),
      sheetno: new FormControl(''),
      EPP_In_Days: new FormControl(30, [Validators.min(0),Validators.required]),
      // UserName: new FormControl('', Validators.required),
    },
    { validators: this.startDateBeforeEndDateValidator }
  );
    this.EPPForm.controls.start_date.disable();
    this.EPPForm.controls.end_date.disable();
    // this.gs.getEpp().subscribe((Response: any) => {
    //   this.users = Response.data;

    // });
  }
  startDateBeforeEndDateValidator(control: AbstractControl): ValidationErrors | null {
    const startDate = control.get('start_date').value;
    const endDate = control.get('end_date').value;

    if (startDate && endDate && startDate > endDate) {
      return { startDateAfterEndDate: true };
    }
    return null;
  }

  selectEvent(e: any) {
    // const v = e.target.selectedIndex;
    this.EPPForm.controls['uname'].setValue(e.UserName + ' - ' + e.UserID);
    if (e) {
      this.EPPForm.controls['group_id'].setValue(e.group_id);
      this.EPPForm.controls['user_id'].setValue(e.UserID);
      this.EPPForm.controls['start_date'].setValue(this.datepipe.transform(e.start_date,'yyyy-MM-dd'));
      this.EPPForm.controls['end_date'].setValue(this.datepipe.transform(e.end_date,'yyyy-MM-dd'));
      this.EPPForm.controls['EPP_In_Days'].setValue(e.EPP_In_Days);
    } else {
      this.EPPForm.controls['group_id'].setValue('');
      this.EPPForm.controls['user_id'].setValue('');
      this.EPPForm.controls['start_date'].setValue('');
      this.EPPForm.controls['end_date'].setValue('');
      this.EPPForm.controls['EPP_In_Days'].setValue(30);
    }
  }
  onChangeSearch(e: string) {
      this.gs.getEpp(`?UserName=${e}`).subscribe((Response: any) => {
      this.users = Response.data;
    },
    (error) => {                              //Error callback
      this.isLoading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
  }
  onChangeBaseDocType() {
    this.baseDocType = this.EPPForm.controls.BaseDocument.value;
    if(this.baseDocType === '0') {
      this.EPPForm.get('taluka').setValidators([Validators.required]);
      this.EPPForm.get('village').setValidators([Validators.required]);
      this.EPPForm.get('citysurveyoffice').clearValidators();
      this.EPPForm.get('ward').clearValidators();
      this.EPPForm.get('sheetno').clearValidators();
      this.EPPForm.get('taluka').updateValueAndValidity();  
      this.EPPForm.get('village').updateValueAndValidity();  
      this.EPPForm.get('citysurveyoffice').updateValueAndValidity();  
      this.EPPForm.get('ward').updateValueAndValidity();  
      this.EPPForm.get('sheetno').updateValueAndValidity();  
    } else if(this.baseDocType === '1') {
      this.EPPForm.get('citysurveyoffice').setValidators([Validators.required]);
      this.EPPForm.get('ward').setValidators([Validators.required]);
      this.EPPForm.get('sheetno').setValidators([Validators.required]);
      this.EPPForm.get('taluka').clearValidators();
      this.EPPForm.get('village').clearValidators();
      this.EPPForm.get('citysurveyoffice').updateValueAndValidity();  
      this.EPPForm.get('ward').updateValueAndValidity();  
      this.EPPForm.get('sheetno').updateValueAndValidity();  
      this.EPPForm.get('taluka').updateValueAndValidity();  
      this.EPPForm.get('village').updateValueAndValidity();  
    } 
  }
  datechange() {
    this.EPPForm.controls['end_date'].setValue(null);
  }
  get f() {
    return this.EPPForm.controls;
  }
  onSubmit() {
    if(this.baseDocType === '1' && this.EPPForm.valid) {
      this.EPPForm.controls.citysurveyoffice.setValue(this.EPPForm.controls.citysurveyoffice.value.trim());
      this.EPPForm.controls.ward.setValue(this.EPPForm.controls.ward.value.trim());
      this.EPPForm.controls.sheetno.setValue(this.EPPForm.controls.sheetno.value.trim());
    } else if(this.baseDocType === '0' && this.EPPForm.valid) {
      this.EPPForm.controls.taluka.setValue(this.EPPForm.controls.taluka.value.trim());
      this.EPPForm.controls.village.setValue(this.EPPForm.controls.village.value.trim());
      
    }
    this.EPPForm.controls.district.setValue(this.EPPForm.controls.district.value.trim());
    this.EPPForm.controls.survey_number.setValue(this.EPPForm.controls.survey_number.value.trim()); 
    if(typeof(this.EPPForm.controls.uname.value) === 'string') {
      this.EPPForm.controls['user_id'].setValue(null);
      this.EPPForm.controls.uname.setValue(this.EPPForm.controls.uname.value.trim());
    }
    this.EPPForm.controls.start_date.enable();
    this.EPPForm.controls.end_date.enable();
    this.submitted = true;
    console.log("EPP controls",this.EPPForm.controls)
    if (this.EPPForm.valid) {
      // 1 is Property ID

      this.isLoading = true;
      this.gs.AddEPP(this.EPPForm.value).subscribe((data) => {
        this.isLoading = false;

        if (data.status === 200) {
          this.submitted = false;
          Swal.fire({
            title: 'EPP Uploaded',
            text: data.message,
            type: 'success',
          }).then(() => {
            this.submitted = false;
            // this.reFresh.emit();
            this.router.navigate(['/epp/view/' + this.EPPForm.value.user_id]);
          });
        } else {
          Swal.fire({
            text: data.message,
            type: 'info',
          });
          this.router.navigate(['/epp/view/' + this.EPPForm.value.user_id]);
        }
      },(error) => {                              //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
    }
  }
}
